<p-toast></p-toast>
<div class="target-system-container">
    <p-card styleClass="p-card-shadow">
        <div class="card dashboardTable">
            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                    <button pButton icon="pi pi-fw pi-plus" label="{{'ADD_GEO_MAPPING'| translate}}" (click)="addTarget()"
                        class="p-button-success"></button>
                    <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
                </ng-template>
                <ng-template pTemplate="right">
                    <!-- <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                    class="p-button-help m-3"></button>
                    <p-menu #menu [popup]="true"  [model]="appVerificationItems"></p-menu> -->
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}"
                        icon="pi pi-refresh" class="p-button-info ml-3"></button>
                </ng-template>

            </p-toolbar>
            <p-table #targetTable [value]="targetTableData" [rows]="10" [paginator]="true" [globalFilterFields]="
                ['AutoID',
                'UserID', 
                'GeoID',
                'GEOType',
                'ActionId',
                'Active']" responsiveLayout="scroll" [(selection)]="targetTableData" [rowHover]="true"
                dataKey="AutoID"
                currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
                [showCurrentPageReport]="true" [loading]="loading">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'GEO_MAPPING'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="targetTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="AutoID">{{'AUTO_ID'| translate}}
                            <p-columnFilter type="text" field="AutoID" display="menu"></p-columnFilter>
                            <p-sortIcon field="AutoID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="UserID">{{'USER_ID'| translate}}
                            <p-columnFilter type="text" field="UserID" display="menu"></p-columnFilter>
                            <p-sortIcon field="UserID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="GeoID">{{'GEO_ID'| translate}}
                            <p-columnFilter type="text" field="GeoID" display="menu"></p-columnFilter>
                            <p-sortIcon field="GeoID"></p-sortIcon>
                        </th>

                        <th pSortableColumn="GEOType">{{'GEO_TYPE'| translate}}
                            <p-columnFilter type="text" field="GEOType" display="menu"></p-columnFilter>
                            <p-sortIcon field="GEOType"></p-sortIcon>
                        </th>

                        <th pSortableColumn="ActionId">{{'ACTION_ID'| translate}}
                            <p-columnFilter type="text" field="ActionId" display="menu"></p-columnFilter>
                            <p-sortIcon field="ActionId"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Active">{{'ACTIVE'| translate}}
                            <p-columnFilter type="text" field="Active" display="menu"></p-columnFilter>
                            <p-sortIcon field="Active"></p-sortIcon>
                        </th>
                        
                        <th>{{'EDIT/DELETE'| translate}}</th>

                    </tr>

                </ng-template>

                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                    <tr>
                        <td>{{product.AutoID}}</td>
                        <td>{{product.UserID}}</td>
                        <td>{{product.GeoID}}</td>
                        <td>{{product.GEOType}}</td>
                        <td>{{product.ActionId}}</td>
                        <td>{{product.Active}}</td>
                        <!-- <td>
                            <button pButton pRipple type="button" icon="pi pi-pencil"
                                (click)="editTarget(product)" class="p-button-rounded p-button-text"></button>

                            <button pButton pRipple type="button" icon="pi pi-times" (click)="onRowDelete(product)"
                                class="p-button-rounded p-button-text p-button-danger"></button>
                        </td> -->
                        <td>
                            <button pButton pRipple type="button" icon="pi pi-pencil"
                                (click)="editTarget(product)" class="p-button-rounded p-button-text"></button>

                            <button pButton pRipple type="button" icon="pi pi-times" (click)="onRowDelete(product)"
                                class="p-button-rounded p-button-text p-button-danger"></button>
                        </td>
                    </tr>
                </ng-template>

            </p-table>
        </div>
    </p-card>
</div>

<p-dialog header="{{'ADD TARGET'| translate}}" [(visible)]="displayTargetDialog" [modal]="true"
    [style]="{width: '90%',height:'70%'}" [maximizable]="true" [draggable]="false" [resizable]="false"
    [baseZIndex]="-100" (onHide)="onCloseDialog()">

    <!-- Content Start-->
    <div class="card dropdown-content" style="margin-bottom: 5px;;">
        <!-- <h4>Estimation Detail</h4> -->
        <form [formGroup]="addTargetDetails">
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-3">
                    <label htmlFor="selectCategory">{{'USER_TYPE'| translate}}</label>
                    <p-dropdown formControlName="userType" [options]="userTypeData" [(ngModel)]="selectedUserType"
                        [ngModelOptions]="{standalone: true}" placeholder="{{'SELECT_USER_TYPE'| translate}}"
                        optionLabel="Level_ID" (onChange)="onSelectUserType()"
                        [ngClass]="{'ng-invalid ng-dirty': addTargetControls?.userType?.touched && addTargetControls?.userType?.errors || isInvalid}">
                    </p-dropdown>

                    <div *ngIf="addTargetControls?.userType?.touched && addTargetControls?.userType?.errors || isInvalid"
                        class="invalid-feedback">
                        <div *ngIf="addTargetControls?.userType?.errors?.required">
                            {{'USER_TYPE_IS_REQUIRED'| translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label htmlFor="selectCategory">{{'USER'| translate}}</label>
                    <p-dropdown formControlName="user" [options]="userData" [(ngModel)]="selectedUserData"
                        [ngModelOptions]="{standalone: true}" placeholder="{{'SELECT_USER'| translate}}"
                        optionLabel="UserID" (onChange)="onSelectUser()"
                        [ngClass]="{'ng-invalid ng-dirty': addTargetControls?.user?.touched && addTargetControls?.user?.errors || isInvalid}">
                    </p-dropdown>

                    <div *ngIf="addTargetControls?.user?.touched && addTargetControls?.user?.errors || isInvalid"
                        class="invalid-feedback">
                        <div *ngIf="addTargetControls?.user?.errors?.required">
                            {{'USER_IS_REQUIRED'| translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label htmlFor="selectCategory">{{'ACTION'| translate}}</label>
                    <p-dropdown formControlName="action" [options]="actionData" [(ngModel)]="selectedActionData"
                        [ngModelOptions]="{standalone: true}" placeholder="{{'SELECT_ACTION'| translate}}"
                        optionLabel="Action" (onChange)="onSelectUser()"
                        [ngClass]="{'ng-invalid ng-dirty': addTargetControls?.action?.touched && addTargetControls?.action?.errors || isInvalid}">
                    </p-dropdown>

                    <div *ngIf="addTargetControls?.action?.touched && addTargetControls?.action?.errors || isInvalid"
                        class="invalid-feedback">
                        <div *ngIf="addTargetControls?.action?.errors?.required">
                            {{'ACTION_IS_REQUIRED'| translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label htmlFor="selectCategory">{{'GEO_TYPE'| translate}}</label>
                    <p-dropdown formControlName="geoType" [options]="geoTypeData" [(ngModel)]="selectedGeoTypeData"
                        [ngModelOptions]="{standalone: true}" placeholder="{{'SELECT_GEO_TYPE'| translate}}"
                        optionLabel="geoTypeName" (onChange)="onSelectGeoType()"
                        [ngClass]="{'ng-invalid ng-dirty': addTargetControls?.geoType?.touched && addTargetControls?.geoType?.errors || isInvalid}">
                    </p-dropdown>

                    <div *ngIf="addTargetControls?.geoType?.touched && addTargetControls?.geoType?.errors || isInvalid"
                        class="invalid-feedback">
                        <div *ngIf="addTargetControls?.geoType?.errors?.required">
                            {{'GEO_TYPE_IS_REQUIRED'| translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label htmlFor="selectCategory">{{'GEO_NAME'| translate}}</label>
                    <p-dropdown formControlName="geoName" [options]="geoTypeName" [(ngModel)]="selectedGeoNameData"
                        [ngModelOptions]="{standalone: true}" placeholder="{{'SELECT_ACTION'| translate}}"
                        optionLabel="Name" (onChange)="onSelectGeoName()"
                        [ngClass]="{'ng-invalid ng-dirty': addTargetControls?.geoName?.touched && addTargetControls?.geoName?.errors || isInvalid}">
                    </p-dropdown>

                    <div *ngIf="addTargetControls?.geoName?.touched && addTargetControls?.geoName?.errors || isInvalid"
                        class="invalid-feedback">
                        <div *ngIf="addTargetControls?.geoName?.errors?.required">
                            {{'GEO_NAME_IS_REQUIRED'| translate}}
                        </div>
                    </div>
                </div>
               
               

                

                

                

                

            </div>
            <button pButton pRipple type="submit" label="{{'SAVE'| translate}}" class="p-button-success mr-2 mb-2"
                (click)="onSaveAddGeoMapping()"></button>
        </form>
    </div>


    <!-- Content End-->
</p-dialog>


<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>
